import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API } from "../config/constants";
import { DEFAULT_SITE_IMAGES } from "../config/siteImages";

const SiteImagesContext = createContext();

export const useSiteImages = () => useContext(SiteImagesContext);

export const SiteImagesProvider = ({ children }) => {
  const [overrides, setOverrides] = useState({});

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/site-images`);
      setOverrides(res.data || {});
    } catch {
      setOverrides({});
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const getImage = (key) => overrides[key] || DEFAULT_SITE_IMAGES[key] || "";

  return (
    <SiteImagesContext.Provider value={{ getImage, overrides, refresh }}>
      {children}
    </SiteImagesContext.Provider>
  );
};
